<template>
  <div id="Zestawienie">
    <md-dialog :md-active.sync="showDialog" :md-click-outside-to-close="false" :md-close-on-esc="false" id="zestawienie">

    <div v-if="loading">
      <app-loader />
    </div>

    <div id="nav" style="width:100%; padding:5px">
      <div style="width:50%; float: left;">
        <button class="btn" @click="generateReport()" style="background: no-repeat; border: 1px solid #C1C1C1;"><img src="../../assets/img/pdf2.svg" width="34"/></button>
      </div>
      <div style="width: 50%; float: right;">
        <button
        class="btn btn-default"
        style="float: right; margin: 5px 34px; color:#007bff;background:#fff;border:1px solid #007bff"
        @click="closeDialog(0)">{{$t('message.zamknij')}}</button>
      </div>
    </div>

      <vue-html2pdf
          :show-layout="false"
          :float-layout="false"
          :enable-download="false"
          :preview-modal="false"
          :paginate-elements-by-height="1400"
          :filename="file_name"
          :pdf-quality="2"
          pdf-format="a4"
          pdf-orientation="portrait"
          pdf-content-width="840px"
          @progress="onProgress($event)"
          @beforeDownload="beforeDownload($event)"
          @hasDownloaded="hasDownloaded($event)"
          ref="html2Pdf"
      >

        <section slot="pdf-content">
          <section class="pdf-item">
            <div id="naglowek">
              <div style="position: relative;">
                <div>
                  <md-dialog-title>{{$t('message.system_zasilania')}}</md-dialog-title>
                  <hr class="new">
                  <p style="font-size: 16px; text-align: center; margin: 5px 0px; font-weight: bold;">
                    {{$t('message.numer_konfi')}}: {{outputs.numer_konfiguracji.value}}</p>
                </div>
                <div style="width: 112px; text-align: center; font-size: 12px;position: absolute; right: 25px;top: 0px;line-height:12px">
                {{$t('message.wydruk')}} <span style="font-weight:bold"> {{ new Date().toLocaleDateString() }}</span></div>
              </div>

              <div class="container" v-if="outputs.zamawiajacy.nazwa !== ''">
                <div class="row" style="width: 790px; font-size: 12px; margin-top: 15px; margin-bottom: 20px;">
                  <hr>
                  <div class="col-sm" style="border-right: 2px solid #eee;">
                    <h5>{{$t('message.zamawiajacy')}}:</h5>
                    <ul>
                      <li>{{outputs.zamawiajacy.nazwa}}</li>
                      <li>{{outputs.zamawiajacy.adres}}</li>
                      <li>{{outputs.zamawiajacy.kod_miasta}} {{outputs.zamawiajacy.miasto}}</li>
                      <li>{{outputs.zamawiajacy.tel}}</li>
                      <li>{{outputs.zamawiajacy.email}}</li>
                      <li>{{outputs.zamawiajacy.nip}}</li>
                    </ul>
                  </div>
                  <div class="col-sm" style="border-right: 2px solid #eee;">
                    <h5>{{$t('message.inwestycja')}}:</h5>
                    <ul>
                      <li>{{outputs.inwestycja.nazwa}}</li>
                      <li>{{outputs.inwestycja.biuro_projektant}}</li>
                      <li>{{outputs.inwestycja.adres}}</li>
                      <li>{{outputs.inwestycja.kod_miasta}} {{outputs.inwestycja.miasto}}</li>
                      <li>{{outputs.inwestycja.tel}}</li>
                      <li>{{outputs.inwestycja.email}}</li>
                    </ul>
                  </div>
                  <div class="col-sm" v-if="outputs.wysylka.nazwa !== ''">
                    <h5>{{$t('message.adres_wysylki')}}:</h5>
                    <ul>
                      <li>{{outputs.wysylka.nazwa}}</li>
                      <li>{{outputs.wysylka.imie_nazwisko}}</li>
                      <li>{{outputs.wysylka.adres}}</li>
                      <li>{{outputs.wysylka.kod_miasta}} {{outputs.inwestycja.miasto}}</li>
                      <li>{{outputs.wysylka.tel}}</li>
                    </ul>
                  </div>
                  <hr>
                </div>
              </div>
            </div>
            <div id="daneTabele">
              <h5>{{$t('message.input_data')}}</h5>
              <table>
                  <tr>
                    <td width=340>{{$t('message.czas_podtrzymania')}}</td><td>{{inputs.czas_podtrzymania.value}}</td>
                  </tr>
                  <tr>
                    <td>{{$t('message.czas_alarmowania')}}</td><td>{{inputs.czas_alarmowania.value}}</td>
                  </tr>
                  <tr>
                    <td>{{$t('message.linie_glosnikowe')}}</td><td>{{inputs.sygnal_pilota.value}}</td>
                  </tr>
                  <tr>
                    <td>{{$t('message.moc_glosnikow')}}</td><td>{{inputs.moc_glosnikow.value}}</td>
                  </tr>
                  <tr>
                    <td>{{$t('message.tryb_poboru')}}</td><td>{{inputs.tryb_poboru_mocy.value}}</td>
                  </tr>
                  <tr>
                    <td>{{$t('message.dodatkowe_u')}}</td><td>{{inputs.dodatkowe_u.value}}</td>
                  </tr>
                  <tr>
                    <td>{{$t('message.sieciowanie')}}</td><td>{{inputs.sieciowanie_systemu.value}}</td>
                  </tr>
              </table>
              <br>
              <h5>{{$t('message.output_data')}}</h5>
              <table>
                <tr>
                  <td width=340>{{$t('message.moc_naglosnienia')}}</td><td>{{inputs.moc_systemu.value}}</td>
                </tr>
                <tr>
                  <td>{{$t('message.liczba_lini')}}</td><td>{{outputs.liczba_lini.value}}</td>
                </tr>
                <tr>
                  <td>{{$t('message.moc_zasilacza')}}</td><td>{{outputs.zasilacz.attributes.moc}}</td>
                </tr>
                <tr>
                  <td>{{$t('message.akumulatory')}}</td><td>{{outputs.akumulator.kod}}</td>
                </tr>
                <tr>
                  <td>{{$t('message.liczba_akumulatorow')}}</td><td>{{outputs.akumulator.ilosc}}</td>
                </tr>
                <tr>
                  <td>{{$t('message.zapas_poj_akum')}}</td><td>{{outputs.zapas_pojemnosci.value}}</td>
                </tr>
                <tr>
                  <td>{{$t('message.przylacze')}}</td><td>{{outputs.przylacze_zasilania.value}}</td>
                </tr>
                <tr>
                  <td>{{$t('message.max_pobor_pradu')}}</td><td>{{pobor_pradu}}</td>
                </tr>
                <tr>
                  <td>{{$t('message.max_moc_cieplna')}}</td><td>{{outputs.moc_cieplna.value}}</td>
                </tr>
                <tr>
                  <td>{{$t('message.zabez_bezp')}}</td><td>{{zabezpieczenia}}</td>
                </tr>
                <tr>
                  <td>{{$t('message.wolne_u')}}</td><td>{{outputs.szafa_wolne_miejsce.value}}</td>
                </tr>
                <tr>
                  <td>{{$t('message.wys_szafy')}}</td><td>{{outputs.szafa.attributes.wysokosc}}</td>
                </tr>
                <tr>
                  <td>{{$t('message.wys_szafy_mm')}}</td><td>{{outputs.szafa.attributes.mm}}</td>
                </tr>
                <tr>
                  <td>{{$t('message.rozmiar_szafy')}}</td><td>{{szafaRozmiar}}</td>
                </tr>
                <tr>
                  <td>{{$t('message.waga_szafy')}}</td><td>{{outputs.szafa.attributes.waga}}</td>
                </tr>
                <tr>
                  <td>{{$t('message.waga_akum')}}</td><td>{{outputs.akumulator.waga}}</td>
                </tr>
                <tr>
                  <td>{{$t('message.waga_instal')}}</td><td>{{outputs.waga_instalacyjna.value}}</td>
                </tr>
              </table>
              <div style="position: relative; right: 290px; bottom: 5px; float: right;">
                <Wizualizacja/>
                <div id="Stacja" style="height: 100%;">
                  <ul style="height: 100%; margin:0px">
                    <li v-if="inputs.wariant2.value > 0"><img src="../../assets/img/urzadzenia/wariant2.png"/></li>
                    <li v-if="inputs.wariant3.value > 0"><img src="../../assets/img/urzadzenia/wariant3.png"/></li>
                    <li v-if="inputs.wariant4.value > 0"><img src="../../assets/img/urzadzenia/wariant4.png"/></li>
                    <li></li>
                  </ul>
                </div>
              </div>
            </div>

          </section>
          <div class="html2pdf__page-break"/>

          <section class="pdf-item">
            <h5>{{$t('message.lista')}}</h5>
            <table class="table" v-if="Object.keys(ListaAkcesoria).length>0 && Object.keys(outputs.stale_w_szafie).length>0">
              <thead>
                <tr>
                  <th scope="col">{{$t('message.kod')}}</th>
                  <th scope="col">{{$t('message.nazwa')}}</th>
                  <th scope="col">{{$t('message.firma')}}</th>
                  <th scope="col">{{$t('message.ilosc')}}</th>
                </tr>
              </thead>
              <tbody>
                <tr><td>{{outputs.szafa.kod}}</td>
                  <td><span v-if="outputs.szafa.nazwa">{{outputs.szafa.nazwa[$i18n.locale]}}</span></td><td>PULSAR</td><td>1</td></tr>
                <tr><td>{{outputs.akumulator.kod}}</td>
                  <td><span v-if="outputs.akumulator.nazwa">{{outputs.akumulator.nazwa[$i18n.locale]}}</span></td><td>PULSAR</td><td>{{outputs.akumulator.ilosc}}</td></tr>
                <tr><td>{{outputs.zasilacz.kod}}</td>
                  <td><span v-if="outputs.zasilacz.nazwa">{{outputs.zasilacz.nazwa[$i18n.locale]}}</span></td><td>PULSAR</td><td>1</td></tr>
                <tr><td>{{outputs.stale_w_szafie.listwaD.kod}}</td>
                  <td><span v-if="outputs.stale_w_szafie.listwaD.nazwa">{{outputs.stale_w_szafie.listwaD.nazwa[$i18n.locale]}}</span></td><td>PULSAR</td><td>1</td></tr>
                <tr><td>{{outputs.stale_w_szafie.listwaZ.kod}}</td>
                  <td><span v-if="outputs.stale_w_szafie.listwaZ.nazwa">{{outputs.stale_w_szafie.listwaZ.nazwa[$i18n.locale]}}</span></td><td>PULSAR</td><td>1</td></tr>

                <tr v-if="inputs.wzmacniacz.value > 0">
                  <td>{{ListaAkcesoria.wzmacniacz.kod}}</td><td>{{ListaAkcesoria.wzmacniacz.nazwa[$i18n.locale]}}</td><td>BOSCH</td><td>{{inputs.wzmacniacz.value}}</td></tr>
                <tr v-if="inputs.wzmacniacz_rezerwowy.value > 0">
                  <td>{{ListaAkcesoria.wzmacniacz.kod}}</td><td>{{ListaAkcesoria.wzmacniacz.nazwa[$i18n.locale]}} {{$t('message.rezerwowy')}}</td><td>BOSCH</td><td>{{inputs.wzmacniacz_rezerwowy.value}}</td></tr>
                <tr v-if="inputs.kontroler.value > 0">
                  <td>{{ListaAkcesoria.kontroler.kod}}</td><td>{{ListaAkcesoria.kontroler.nazwa[$i18n.locale]}}</td><td>BOSCH</td><td>1</td></tr>
                <tr v-if="inputs.router.value > 0">
                  <td>{{ListaAkcesoria.router.kod}}</td><td>{{ListaAkcesoria.router.nazwa[$i18n.locale]}}</td><td>BOSCH</td><td>{{inputs.router.value}}</td></tr>

                <tr v-if="ListaAkcesoria.mikrofon.sztuk > 0">
                  <td>{{ListaAkcesoria.mikrofon.kod}}</td><td>{{ListaAkcesoria.mikrofon.nazwa[$i18n.locale]}}</td><td>BOSCH</td><td>{{ListaAkcesoria.mikrofon.sztuk}}</td></tr>
                <tr v-if="ListaAkcesoria.rozszerzenie.sztuk > 0">
                  <td>{{ListaAkcesoria.rozszerzenie.kod}}</td><td>{{ListaAkcesoria.rozszerzenie.nazwa[$i18n.locale]}}</td><td>BOSCH</td><td>{{ListaAkcesoria.rozszerzenie.sztuk}}</td></tr>

                <tr><td>{{ListaAkcesoria.sygnalizator.kod}}</td><td>{{ListaAkcesoria.sygnalizator.nazwa[$i18n.locale]}}</td><td>PULSAR</td><td>1</td></tr>
                <tr v-if="inputs.panel_wentylacyjny.value > 0">
                  <td>{{ListaAkcesoria.wentylator.kod}}</td><td>{{ListaAkcesoria.wentylator.nazwa[$i18n.locale]}}</td><td>PULSAR</td><td>1</td></tr>
                <tr v-if="inputs.panel_wentylacyjny.value > 0">
                  <td>{{ListaAkcesoria.zaslepka.kod}}</td><td>{{ListaAkcesoria.zaslepka.nazwa[$i18n.locale]}}</td><td>PULSAR</td><td>1</td></tr>

                <tr v-if="inputs.wariant3.value > 0">
                  <td>{{ListaAkcesoria.obudowa_mikrofonu.kod}}</td><td>{{ListaAkcesoria.obudowa_mikrofonu.nazwa[$i18n.locale]}}</td><td>PULSAR</td><td>1</td></tr>
                <tr v-if="inputs.wariant4.value > 0">
                  <td>{{ListaAkcesoria.obudowa_zasilacza.kod}}</td><td>{{ListaAkcesoria.obudowa_zasilacza.nazwa[$i18n.locale]}}</td><td>PULSAR</td><td>1</td></tr>

                <tr v-if="inputs.obudowa_plytki.value > 0">
                  <td>{{ListaAkcesoria.obudowa_plytki.kod}}</td><td>{{ListaAkcesoria.obudowa_plytki.nazwa[$i18n.locale]}}</td><td>PULSAR</td><td>1</td></tr>
                <tr v-if="inputs.kolka.value > 0">
                  <td>{{ListaAkcesoria.kolka.kod}}</td><td>{{ListaAkcesoria.kolka.nazwa[$i18n.locale]}}</td><td>PULSAR</td><td>{{inputs.kolka.value}}</td></tr>
              </tbody>
            </table>
          </section>
          <div class="html2pdf__page-break"/>

          <section class="pdf-item" v-if="$i18n.locale === 'pl'">
            <h5>{{$t('message.wycena')}}</h5>
            <table class="table" v-if="Object.keys(ListaAkcesoria).length>0 && Object.keys(outputs.stale_w_szafie).length>0">
              <thead>
                <tr>
                  <th width=450>{{$t('message.opis')}}</th>
                  <th>{{$t('message.ilosc_sztuk')}}</th>
                  <th>{{$t('message.cena_netto_szt')}}</th>
                  <th>{{$t('message.wartosc_net')}}</th>
                  <th>{{$t('message.rabat')}}</th>
                  <th>{{$t('message.cena_net_sztuka')}}</th>
                  <th>{{$t('message.wartosc_net_rabat')}}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{outputs.numer_konfiguracji.value}}</td>
                  <td>1</td>
                  <td>{{outputs.cena_netto_systemu_bez_rabatu.value}}</td>
                  <td>{{outputs.cena_netto_systemu_bez_rabatu.value}}</td>
                  <td>{{outputs.rabat.value}}%</td>
                  <td>{{outputs.cena_netto_systemu.value}}</td>
                  <td>{{outputs.cena_netto_systemu.value}}</td>
                </tr>
                <tr v-if="inputs.obudowa_plytki.value > 0">
                  <td>{{ListaAkcesoria.obudowa_plytki.kod}} - {{ListaAkcesoria.obudowa_plytki.nazwa[$i18n.locale]}}</td>
                  <td>{{inputs.obudowa_plytki.value}}</td>
                  <td>{{ListaAkcesoria.obudowa_plytki.attributes.cena}}</td>
                  <td>{{cena(inputs.obudowa_plytki.value, ListaAkcesoria.obudowa_plytki.attributes.cena)}}</td>
                  <td>{{outputs.rabat.value}}%</td>
                  <td>{{cena_rabat_sztuka((ListaAkcesoria.obudowa_plytki.attributes.cena))}}</td>
                  <td>{{cena_rabat(inputs.obudowa_plytki.value, ListaAkcesoria.obudowa_plytki.attributes.cena)}}</td>
                </tr>
                <tr v-if="inputs.wariant3.value > 0">
                  <td>{{ListaAkcesoria.obudowa_mikrofonu.kod}} - {{ListaAkcesoria.obudowa_mikrofonu.nazwa[$i18n.locale]}}</td>
                  <td>{{ListaAkcesoria.obudowa_mikrofonu.sztuk}}</td><td>{{Number(ListaAkcesoria.obudowa_mikrofonu.attributes.cena).toFixed(2)}}</td>
                  <td>{{cena(inputs.wariant3.value, ListaAkcesoria.obudowa_mikrofonu.attributes.cena)}}</td>
                  <td>{{outputs.rabat.value}}%</td>
                  <td>{{cena_rabat_sztuka(ListaAkcesoria.obudowa_mikrofonu.attributes.cena)}}</td>
                  <td>{{cena_rabat(inputs.wariant3.value, ListaAkcesoria.obudowa_mikrofonu.attributes.cena)}}</td>
                </tr>
                <tr v-if="inputs.wariant4.value > 0">
                  <td>{{ListaAkcesoria.obudowa_zasilacza.kod}} - {{ListaAkcesoria.obudowa_zasilacza.nazwa[$i18n.locale]}}</td>
                  <td>{{ListaAkcesoria.obudowa_zasilacza.sztuk}}</td><td>{{Number(ListaAkcesoria.obudowa_zasilacza.attributes.cena).toFixed(2)}}</td>
                  <td>{{cena(inputs.wariant4.value, ListaAkcesoria.obudowa_zasilacza.attributes.cena)}}</td>
                  <td>{{outputs.rabat.value}}%</td>
                  <td>{{cena_rabat_sztuka(ListaAkcesoria.obudowa_zasilacza.attributes.cena)}}</td>
                  <td>{{cena_rabat(inputs.wariant4.value, ListaAkcesoria.obudowa_zasilacza.attributes.cena)}}</td>
                </tr>
                <tr v-if="inputs.kolka.value > 0">
                  <td>{{ListaAkcesoria.kolka.kod}} - {{ListaAkcesoria.kolka.nazwa[$i18n.locale]}}</td>
                  <td>{{ListaAkcesoria.kolka.sztuk}}</td><td>{{ListaAkcesoria.kolka.attributes.cena}}</td>
                  <td>{{cena(inputs.kolka.value, ListaAkcesoria.kolka.attributes.cena)}}</td>
                  <!-- <td>{{outputs.rabat.value}}%</td> -->
                  <td>0%</td>
                  <td>{{ListaAkcesoria.kolka.attributes.cena}}</td>
                  <td>{{cena(inputs.kolka.value, ListaAkcesoria.kolka.attributes.cena)}}</td>
                </tr>
              </tbody>
            </table>
            <div style="height:50px"></div>

            <div id="wycena" style="height:410px">
              <div id="wycenaContent" style="position:relative">
                <div>
                  <div style="height:30px; width:450px; float:left; font-size:16px">System zasilania DSO</div>
                  <div style="width: 300px; position: absolute; right: 0px;">Cena netto sztuka po rabacie [PLN]</div>
                </div>
                <div>
                  <div class="content-element-lista"><span>System zasilania DSO</span>
                    <div class="content-cena" style="height: 60px;"><span style="position: absolute;top: 20px;left: 55px;">{{outputs.cena_netto_systemu.value}}</span></div>
                  </div>
                </div>
              </div>
              <div style="height:135px"></div>
              <div id="wycenaContent" style="position:relative">
                <div>
                  <div style="height:30px; width:450px; float:left; font-size:16px">Wyposażenie dodatkowe</div>
                  <div style="width: 300px; position: absolute; right: 0px;">Wartość netto po rabacie [PLN]</div>
                </div>
                <div>
                  <div v-if="inputs.obudowa_plytki.value > 0 || inputs.wariant3.value > 0 || inputs.wariant4.value > 0 || inputs.kolka.value > 0">
                    <div v-if="inputs.obudowa_plytki.value > 0" class="content-element-lista"><span>{{ListaAkcesoria.obudowa_plytki.kod}} - {{ListaAkcesoria.obudowa_plytki.nazwa[$i18n.locale]}}</span></div>
                    <div v-if="inputs.wariant3.value > 0" class="content-element-lista"><span>{{ListaAkcesoria.obudowa_mikrofonu.kod}} - {{ListaAkcesoria.obudowa_mikrofonu.nazwa[$i18n.locale]}}</span></div>
                    <div v-if="inputs.wariant4.value > 0" class="content-element-lista"><span>{{ListaAkcesoria.obudowa_zasilacza.kod}} - {{ListaAkcesoria.obudowa_zasilacza.nazwa[$i18n.locale]}}</span></div>
                    <div v-if="inputs.kolka.value > 0" class="content-element-lista"><span>{{ListaAkcesoria.kolka.kod}} - {{ListaAkcesoria.kolka.nazwa[$i18n.locale]}}</span></div>
                    <div class="content-cena" :style="styleObject"><span style="position: absolute;top: 35%; left: 35%;">{{cena_rabat_dodatkowe}}</span></div>
                  </div>
                  <div v-else>
                    <div class="content-element-lista"></div>
                  <div class="content-cena" :style="styleObject"><span style="position: absolute;top: 35%; left: 45%;">0</span></div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <div class="html2pdf__page-break"/>

        </section>
      </vue-html2pdf>

    </md-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import VueHtml2pdf from 'vue-html2pdf'
import Wizualizacja from '../Wizualizacja'
import WizualizacjaStacji from '../WizualizacjaStacji'

export default {
  name: 'Zestawienie',
  props: ['showDialog'],
  data () {
    return {
      page: 'dane',
      file_name: 'confi-dso-' + new Date().toLocaleDateString(),
      exporting: false
    }
  },
  components: {
    Wizualizacja, VueHtml2pdf, WizualizacjaStacji
  },
  computed: {
    ...mapGetters('app', ['loading']),
    ...mapGetters('app', ['config']),
    ...mapGetters('app', ['inputs']),
    ...mapGetters('app', ['outputs']),
    ...mapGetters('products', ['ListaSzafy']),
    ...mapGetters('products', ['ListaAkcesoria']),
    ...mapGetters('products', ['ListaAkumulatory']),
    ...mapGetters('products', ['ListaZasilacze']),
    ...mapGetters('products', ['ListaListwyD']),
    ...mapGetters('products', ['ListaListwyZ']),
    // ...mapGetters('products', ['ListaMaterialy']),
    getImgUrl () {
      var iloscU = (this.outputs.szafa.attributes.wysokosc === '') ? '24' : this.outputs.szafa.attributes.wysokosc
      return require('../../assets/img/szafa/szafa_' + iloscU + '.png')
    },
    szafaRozmiar () {
      if (this.outputs.szafa.attributes.szerokosc !== '' && this.outputs.szafa.attributes.glebokosc !== '') {
        return this.outputs.szafa.attributes.szerokosc + 'x' + this.outputs.szafa.attributes.glebokosc
      } else {
        return ''
      }
    },
    pobor_pradu () {
      if (this.outputs.ilosc_faz.value > 0 && this.outputs.pobor_pradu.value > 0) {
        return this.outputs.ilosc_faz.value + 'x' + this.outputs.pobor_pradu.value.toFixed(1)
      } else {
        return ''
      }
    },
    zabezpieczenia () {
      if (this.outputs.ilosc_faz.value > 0 && this.outputs.zabezpieczenia.value > 0) {
        return this.outputs.ilosc_faz.value + 'x' + this.outputs.zabezpieczenia.value
      } else {
        return ''
      }
    },
    cena_dodatkowa () {
      return ''
    },
    styleObject () {
      var high = 20
      if (this.inputs.obudowa_plytki.value > 0) {
        high += 40
      }
      if (this.inputs.wariant3.value > 0) {
        high += 40
      }
      if (this.inputs.wariant4.value > 0) {
        high += 40
      }
      if (this.inputs.kolka.value > 0) {
        high += 40
      }
      if (high === 20) {
        high += 40
      }
      return 'height: ' + high + 'px'
    },
    cena_rabat_dodatkowe () {
      var price = 0
      if (this.inputs.obudowa_plytki.value > 0) {
        var cenaObudowaPlytki = this.ListaAkcesoria.obudowa_plytki.attributes.cena * this.inputs.obudowa_plytki.value
        price += (cenaObudowaPlytki - (cenaObudowaPlytki * (this.outputs.rabat.value / 100)))
      }
      if (this.inputs.wariant3.value > 0) {
        var cenaObudowaMikrofonu = this.ListaAkcesoria.obudowa_mikrofonu.attributes.cena * this.inputs.wariant3.value
        price += (cenaObudowaMikrofonu - (cenaObudowaMikrofonu * (this.outputs.rabat.value / 100)))
      }
      if (this.inputs.wariant4.value > 0) {
        var cenaObudowaZasilacza = this.ListaAkcesoria.obudowa_zasilacza.attributes.cena * this.inputs.wariant4.value
        price += (cenaObudowaZasilacza - (cenaObudowaZasilacza * (this.outputs.rabat.value / 100)))
      }
      if (this.inputs.kolka.value > 0) {
        var cenaKolka = this.ListaAkcesoria.kolka.attributes.cena * this.inputs.kolka.value
        price += cenaKolka
      }

      return parseFloat(Number(price)).toFixed(2)
    }
  },
  methods: {
    closeDialog () {
      this.$emit('clickedClose', false)
    },
    cena (sztuk, cena) {
      return parseFloat(sztuk * cena).toFixed(2)
    },
    cena_rabat_sztuka (cena) {
      return parseFloat(cena - (cena * (this.outputs.rabat.value / 100))).toFixed(2)
    },
    cena_rabat (sztuk, cena) {
      return parseFloat((sztuk * cena) - ((sztuk * cena) * (this.outputs.rabat.value / 100))).toFixed(2)
    },
    dodatkowy_procent (wartosc) {
      return parseFloat(Number(wartosc) + (Number(wartosc) * (this.config.cennik.procent / 100))).toFixed(2)
    },
    generateReport () {
      this.$refs.html2Pdf.generatePdf()
    },
    async beforeDownload ({ html2pdf, options, pdfContent }) {
      await html2pdf().set(options).from(pdfContent).toPdf().get('pdf').then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages()
        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i)
          pdf.setFontSize(10)
          pdf.setTextColor(150)
          pdf.text('Strona ' + i + ' z ' + totalPages, (pdf.internal.pageSize.getWidth() * 0.88), (pdf.internal.pageSize.getHeight() - 0.3))
        }
        this.$store.commit('app/SET_LOADING', !this.loading, { root: true })
      }).save()
    },
    onProgress ({ html2pdf, options, pdfContent }) {
      this.$store.commit('app/SET_LOADING', !this.loading, { root: true })
    },
    hasDownloaded ({ html2pdf, options, pdfContent }) {
      // console.log('hasDownloaded')
    }
  }
}
</script>

<style scoped>
#Zestawienie {
  font-size: 14px;
}
#Zestawienie table tr {
height: 25px;
}
#Zestawienie .md-dialog .md-dialog-container {
    width: 920px !important;
    max-width: 1024px !important;
}
#Wizualizacja {
  transform: scale(0.75);
}
#Stacja {
transform: scale(0.25);
width: 440px;
position: absolute;
bottom: 164px;
left: -225px;
}
#Stacja ul li {
display: inline-block;
margin: 10px 10px;
}

#naglowek ul {
  margin-bottom:0px;
  line-height: 12px;
}
#naglowek ul li {
  display: block;
  margin: 0px;
}

.vue-html2pdf {
  overflow: auto;
  overflow-x: hidden;
}
section.pdf-item {
  margin-bottom: 100px;
  padding: 15px;
}
.table {
  width: 94%;
}
.table tr {
  line-height: 8px;
}
.table tr td{
  line-height: 12px;
}

.table thead th {
font-size: 12px;
line-height: 12px;
}
.col-sm {
  text-align: center;
  padding: 0px;
}
.col-sm h5 {
  text-align: center;
}
.md-avatar[data-v-1b4e33f8] {
    width: 0px;
    min-width: 20px;
    height: 28px;
    border-radius: 0px;
    margin-left: 34px;
    margin-right: 10px;
}
.tooltipShort  {
  padding:10px;
  width:300px;
  height:110px;
  font-size: 14px;
}

.content-cena {
  position: absolute;
  right: 105px;
  width: 180px;
  background: rgb(102, 102, 102) none repeat scroll 0% 0%;
  top: 20px;
  font-size: 18px;
  font-weight: bold;
  color: white;
}
.content-element-lista {
  height: 40px;
  width: 740px;
  float: left;
  margin-left: 15px;
  font-size: 16px;
  font-weight: bold;
  background: #ccc;
  padding: 0px;
}
.content-element-lista span {
  padding: 0px 10px;
  line-height: 38px;
}

section.content-wrapper {
  padding:10px
}

#daneTabele {
  position: relative;
  /* margin-left: 32px;
margin-top: 20px; */
}

hr.new {
  border: 2px solid #1F5D89;
  border-radius: 5px;
  width: 300px;
  margin: 0px auto;
}
.btn-primary {
    color: #fff;
    background-color: rgb(59, 163, 255);
    border-color:rgb(59, 163, 255);
}
.dialogZestawienie {
min-height: 892px;
max-height: 892px;
}
#zestawienie div.md-dialog-container {
  width:820px !important;
  max-width: 820px !important;
  max-width: 820px !important;

}
  .md-avatar[data-v-1b4e33f8] {
      width: 0px;
      min-width: 20px;
      height: 28px;
      border-radius: 0px;
      margin-left: 34px;
      margin-right: 10px;
  }
  .tooltipShort  {
    padding:10px;
    width:300px;
    height:110px;
    font-size: 14px;
  }
  .md-dialog-title {
padding: 0px 0px 0;
color: #1F5D89;
font-weight: bold;
margin: auto;
width: 100%;
display: block;
text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dialogs/Podsumowanie.vue